import React from 'react';

const Spinner = ({show}) => {
  if (!show) return null;
  return (
    <div className="overlay"><i className="fa fa-sync fa-spin"></i></div>
  );
};
export default Spinner;



// WEBPACK FOOTER //
// ../hyperdb-utils/src/components/ui-react/Spinner.jsx